import React, { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  Box,
  Card,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Button,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack5";
import {
  createAgentApi,
  updateb2bAgnetApi,
} from "src/Api/Services/AgentFareRule";
import { Col, Row } from "react-bootstrap";
const UpdateAgentFareRuleComp = ({
  agentList,
  fetchData,
  setShow,
  editData,
}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      role: "",
      logo: "",
      perAccess: [],
    },
    validate: (values) => {
      const errors = {};
      if (!values.username) {
        errors.username = "User Name is required";
      }
      if (!values.password) {
        errors.password = "Password is required";
      }
      if (!values.role) {
        errors.role = "Role is required";
      }
      if (values.perAccess.length === 0) {
        errors.perAccess = "Permission is required";
      }
      return errors;
    },
    onSubmit: (values) => {
      handleUpdateApiCall();
    },
  });
  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    handleChange,
    values,
    setFieldValue,
    setSubmitting,
    resetForm,
    handleBlur,
  } = formik;

  const handleUpdateApiCall = async () => {
    const { perAccess, ...rest } = values;
    try {
      const { data } = await updateb2bAgnetApi({
        ...rest,
        userid: editData.userid,
        permissions: {
          pList: [{ name: "farerule", access: perAccess }],
        },
      });
      if (data.status) {
        fetchData();
        resetForm();
        setShow(false);
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setSubmitting(false);
  };
  useEffect(() => {
    if (editData) {
      setFieldValue("username", editData.username);
      setFieldValue("password", editData.password);
      setFieldValue("role", editData.role);
      setFieldValue("logo", editData.logo);
      setFieldValue("perAccess", editData.permissions?.pList[0]?.access || []);
    }
  }, [editData]);
  console.log({ values });
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} xs={12} xl={3}>
            <TextField
              type="text"
              placeholder="Enter user name"
              size="normal"
              label="User Name"
              name="username"
              value={values.username}
              onChange={handleChange}
              error={errors.username && touched.username}
              fullWidth
              onBlur={handleBlur}
              disabled
            />
            {errors.username && touched.username && (
              <FormHelperText error id="component-error-text">
                {errors.username}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={3}>
            <TextField
              type="text"
              placeholder="Enter user password"
              size="normal"
              label="Password"
              name="password"
              value={values.password}
              onChange={handleChange}
              error={errors.password && touched.password}
              fullWidth
              onBlur={handleBlur}
            />
            {errors.password && touched.password && (
              <FormHelperText error id="component-error-text">
                {errors.password}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={3}>
            <FormControl fullWidth size="normal">
              <InputLabel id="demo-simple-select-label">Role</InputLabel>
              <Select
                name="role"
                value={values.role}
                onChange={handleChange}
                error={errors.role && touched.role}
                label="Role"
                onBlur={handleBlur}
              >
                <MenuItem value="user">User</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="agent">Agent</MenuItem>
              </Select>
            </FormControl>
            {errors.role && touched.role && (
              <FormHelperText error id="component-error-text">
                {errors.role}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Logo</InputLabel>
              <Select
                name="logo"
                value={values.logo}
                onChange={handleChange}
                label="Logo"
              >
                {logoList.map((it) => (
                  <MenuItem value={it.value}>{it.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Col>
          <Col md={12} xs={12} xl={6}>
            {agentList.length > 0 && (
              <Autocomplete
                multiple
                id="multi-select-autocomplete"
                options={agentList}
                // getOptionLabel={(option) => option}
                value={values.perAccess}
                name="perAccess"
                onChange={(e, value) => setFieldValue("perAccess", value)}
                size="normal"
                fullWidth
                className="mt-4"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Permissions access"
                    variant="outlined"
                    error={errors.perAccess && touched.perAccess}
                    onBlur={handleBlur}
                  />
                )}
              />
            )}
            {errors.perAccess && touched.perAccess && (
              <FormHelperText error id="component-error-text">
                {errors.perAccess}
              </FormHelperText>
            )}
          </Col>
        </Row>
        <div className="text-center mt-4">
          <Button variant="contained" type="submit" disabled={isSubmitting}>
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default UpdateAgentFareRuleComp;
const logoList = [
  { name: "Travomint", value: "Travomint.png" },
  { name: "Wego", value: "wego.png" },
  { name: "Jetcost", value: "jetcost.png" },
  { name: "Jetradar", value: "jetradar.png" },
  { name: "Momondo", value: "momondo.png" },
];
